import axios from "axios";
import { Startup } from "../Classes/Startup";
import { plainToInstance } from "class-transformer";
const url = "/api/startup";

export const axiosStartupPage = async (
  campaignId: string
): Promise<Startup | null> => {
  const response = await axios.get(`${url}/${campaignId}`);
  if (response.data == null) return null;
  const startup = plainToInstance(Startup, [response.data], {
    excludeExtraneousValues: true,
  })[0];
  return startup;
};
